import React, { useState, useEffect, useCallback } from "react";
import "./App.css";
import { Route, Routes } from "react-router-dom";
import Home from "./components/main/Home";
import Services from "./components/pages/services/Services";
import Contact from "./components/pages/contact/Contact";
import { ConfigProvider } from "antd";
import Portfolio from "./components/pages/portfolio/Portfolio";
import Resume from "./components/pages/resume/Resume";
import Projects from "./components/pages/projects/Projects";
import NotFound from "./NotFound";
import SingleProject from "./components/pages/projects/SingleProject";
import Checkout from "./components/pages/checkout/Checkout";
import HomeLayout from "./components/main/HomeLayout";
function App() {
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [darkMode, setDarkMode] = useState(false);
  const windowQuery = window.matchMedia("(prefers-color-scheme:dark)");

  const darkModeChange = useCallback((event) => {
    // console.log(event.matches ? true : false);
    setDarkMode(event.matches ? true : false);
  }, []);

  useEffect(() => {
    windowQuery.addEventListener("change", darkModeChange);
    return () => {
      windowQuery.removeEventListener("change", darkModeChange);
    };
  }, [windowQuery, darkModeChange]);

  useEffect(() => {
    // console.log(windowQuery.matches ? true : false);
    setDarkMode(windowQuery.matches ? true : false);
  }, [windowQuery.matches]);
  const handleWindowResize = () => {
    setScreenWidth(window.innerWidth);
  };
  const lightTheme = {
    token: {
      colorPrimary: "#0abacc",
      colorBgBase: "#fff",
      colorTextBase: "#000",
      fontFamily: "sans-serif",
    },
  };
  const darkTheme = {
    token: {
      colorPrimary: "#0abacc",
      colorBgBase: "#1a1a1a",
      colorTextBase: "#ccc",
      fontFamily: "sans-serif",
    },
  };

  const toggleTheme = () => {
    setDarkMode(!darkMode);
  };
  // Add a resize event listener when the component mounts
  useEffect(() => {
    window.addEventListener("resize", handleWindowResize);
    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, []);
  return (
    <>
      <ConfigProvider theme={darkMode ? darkTheme : lightTheme}>
        <Routes>
          <Route
            path="/"
            element={
              <HomeLayout
                screenWidth={screenWidth}
                toggleTheme={toggleTheme}
                darkMode={darkMode}
              />
            }
          >
            <Route index element={<Home screenWidth={screenWidth} />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route
              path="/services"
              element={<Services screenWidth={screenWidth} />}
            />
            <Route
              path="/projects"
              element={<Projects screenWidth={screenWidth} />}
            />
            <Route path="/projects/:id" element={<SingleProject />} />
            <Route path="/resume" element={<Resume />} />
            <Route
              path="/contact"
              element={<Contact screenWidth={screenWidth} />}
            />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </ConfigProvider>
    </>
  );
}

export default App;
